module.exports = __webpack_public_path__ + "static/media/ic_app_emulation_small.5641e648.svg";